import { bezierSpline } from '@turf/turf';
import { lineString } from '@turf/helpers';

import SnapLineMode from './SnapLineMode';
import { drawModes, drawState } from '../../Types';

/**
 * BezierMode: draws a polyline as a control path with snap support, then
 * smooths it into a Bezier spline on completion.
 *
 * UX matches SuperMap MapStudio's "bezier curve" sub-tool:
 *   - User clicks vertices like a regular polyline
 *   - On completion (double-click / right-click) the captured control points
 *     are smoothed into a higher-resolution curve
 *   - Curve resolution and sharpness use turf's bezierSpline defaults
 */
const BezierMode: drawModes = <drawModes>{ ...SnapLineMode };

const baseOnStop = (SnapLineMode as any).onStop;

BezierMode.onStop = function (state: drawState) {
  try {
    const lineFeature = state?.line;
    const coords = lineFeature?.coordinates as number[][] | undefined;

    if (Array.isArray(coords) && coords.length >= 3) {
      const smoothed = bezierSpline(lineString(coords));
      const next = smoothed?.geometry?.coordinates;
      if (Array.isArray(next) && next.length >= 2 && lineFeature) {
        try {
          (lineFeature as any).incomingCoords?.(next);
        } catch {
          (lineFeature as any).coordinates = next;
        }
      }
    }
  } catch {
    /* fallback: keep raw polyline */
  }

  if (typeof baseOnStop === 'function') {
    baseOnStop.call(this, state);
  }
};

export default BezierMode;
